<template>
  <b-modal
    ref="shutdownResellerConfirm"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable
    @hidden="unselectReseller()">

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        When a reseller is disabled, all active users associated with this reseller will be disconnected. Are you sure you want to disable this reseller?
      </p>
    </b-alert>

    <reseller-details-plate />

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('shutdownResellerConfirm')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="resellersResponses('switchReseller')"
          @click="switchReseller(), hideModal('shutdownResellerConfirm')">
          Yes, turn it off
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  GET_RESELLERS,
  SWITCH_RESELLER,
  UNSELECT_RESELLER
} from '@/core/services/store/resellers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import ResellerDetailsPlate from './ResellerDetailsPlate.vue'

export default {
  name: 'ModalShutdownReseller',
  components: {
    ResellerDetailsPlate
  },
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'selectedReseller',
      'selectedResellerId',
      'resellerStatusBadge',
      'resellersResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectReseller() {
      this.$store.commit(UNSELECT_RESELLER)
    },

    getResellers() {
      this.$store.dispatch(GET_RESELLERS)
    },

    switchReseller() {
      this.$store
        .dispatch(SWITCH_RESELLER, { id: this.selectedReseller.id })
        .then(() => {
          if (this.$route.query.status) {
            this.getResellers()
          }
        })
    },
  }
}
</script>
